import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import RenewalsPage from './RenewalsPage';
import { updateAuth } from '../../actions/user';
import { PageWithNavigation } from '../../components';

/**
 * Orders Page RefundPage
 */

export type ListItemType = {
  data: {
    id: number;
    date: string;
    status: string;
    totalAmount: number;
    currencyCode: string;
    isBalance: boolean;
    merchantName: string;
    storeName: string;
    merchantOrderCode: string;
  };
  onClick: any;
  selected?: string | number;
  t: any;
  isOffline: boolean;
};

export default () => {
  const { t } = useTranslation();
  const history = useHistory();
  // const params: any = useParams();
  const dispatch = useDispatch();

  return (
    <>
      <Helmet>
        <title>{t('subscriptions')}</title>
      </Helmet>
      <PageWithNavigation updateAuth={updateAuth}>
        <RenewalsPage
          t={t}
          useSelector={useSelector}
          type="cashew"
          history={history}
          dispatch={dispatch}
        />
      </PageWithNavigation>
    </>
  );
};
